import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function TopBar({ subtitle = 'Est. 1890s', chip, children }) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const homePath = isAuthenticated ? '/lobby' : '/login';

  return (
    <header className="top-bar">
      <button type="button" className="brand" onClick={() => navigate(homePath)} aria-label="Go home">
        <span className="brand-mark" aria-hidden="true">
          N
        </span>
        <span className="brand-text">
          <span className="brand-name">Game of Numerica</span>
          <span className="brand-sub">{subtitle}</span>
        </span>
        {chip && <span className="chip ms-2 d-none d-sm-inline-flex">{chip}</span>}
      </button>
      <nav className="top-bar-nav">{children}</nav>
    </header>
  );
}

export default TopBar;
